if (!customElements.get('text-ticker')) {
  customElements.define(
      'text-ticker',
      class TextTicker extends HTMLElement {
        constructor() {
          super();

          this.el = this.querySelector('.text-ticker');
          this.template = this.querySelector(".text-ticker__text");
          this.texts = [this.template];

          this._resized = false;

          this.init();

          this._onIntersection = this._onIntersection.bind(this);
          this._detectResize = this._detectResize.bind(this);
        }

        init(){
          this._onResize();
          this.observer = new IntersectionObserver(this._onIntersection);

          this.observer.observe(this.el);

          window.addEventListener('resize', () => {
            this._resized = true;
          });

          this.interval = setInterval(() => this._detectResize(), 1000);
        }

        _onIntersection(entries) {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if(entry.target.classList.contains('in-view')) return;
              entry.target.classList.add('in-view');
            } else {
              if(!entry.target.classList.contains('in-view')) return;
              entry.target.classList.remove('in-view');
            }
          });
        }

        _detectResize(){
          if( !this._resized ) return;
          
          this._resized = false;
          this._onResize();
        }

        _onResize(){
          const elRect = this.el.getBoundingClientRect();
          const textRect = this.template.getBoundingClientRect();

          if( elRect.width < 1 || textRect.width < 1 ) return;

          this._maximum = textRect.width * -1;

          const quantity = Math.ceil(elRect.width / textRect.width) + 1;

          while( this.texts.length < quantity ) {
            const copy = this.template.cloneNode(true);
                  copy.setAttribute('aria-hidden', true);
                  copy.style.setProperty('--ticker-index', this.texts.length);

            this.texts.push(copy);
            this.el.appendChild(copy);
          }
        }
      }
  );
};